var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"try",on:{"click":_vm.tryClick}},[_vm._v("免费使用")])])
}
var staticRenderFns = []

export { render, staticRenderFns }